
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.508 1.754H2.492A2.492 2.492 0 000 4.247v3.507a2.492 2.492 0 002.492 2.492h7.016A2.492 2.492 0 0012 7.754V4.247a2.492 2.492 0 00-2.492-2.493zM7.822 6.171L4.541 7.736a.132.132 0 01-.189-.12V4.39c0-.098.104-.162.192-.118l3.281 1.663c.098.05.096.19-.003.237z","fill":"#000"}})])
          )
        }
      }
    